const sliders = {
    el: {
        sliderContainer: $('.js-slider'),
    },

    events(elemContainer) {
        const container = $(elemContainer);
        const sliderCentered = container.data('slider-centered');
        const sliderLoop = container.data('slider-loop');
        const sliderAutoPlay = container.data('slider-autoplay');
        const sliderSizeLarge = container.data('slider-size-large');
        const sliderSizeMedium = container.data('slider-size-medium');
        const sliderSizeSmall = container.data('slider-size-small');
        const sliderFraction = container.data('slider-fraction');
        const sliderSpaceBetween = container.data('slider-space-between');
        const sliderFreeMode = container.data('slider-free-mode');
        const outterArrows = container.data('slider-outter-arrows');
        const outterPagination = container.data('slider-outter-pagination');

        new Swiper(container, {
            slidesPerView: sliderSizeLarge ? sliderSizeLarge : 1,
            centeredSlides: sliderCentered ? sliderCentered : '',
            loop: sliderLoop ? sliderLoop : '',
            // loopedSlides: sliderSizeLarge ? sliderSizeLarge : 1,
            // slidesPerGroup: sliderSizeLarge ? sliderSizeLarge : 1,
            // loopAdditionalSlides: sliderSizeLarge ? sliderSizeLarge : 1,
            spaceBetween: sliderSpaceBetween ? sliderSpaceBetween : 0,
            freeMode: sliderFreeMode ? sliderFreeMode : false,
            navigation: {
                nextEl: outterArrows ? container.parent().parent().find('.swiper-button-next') : container.find('.swiper-button-next'),
                prevEl: outterArrows ? container.parent().parent().find('.swiper-button-prev') : container.find('.swiper-button-prev'),
            },

            pagination: {
                el: outterPagination ? container.parent().parent().find('.swiper-pagination') : container.find('.swiper-pagination'),
                clickable: sliderFraction ? false : true,
                type: sliderFraction ? 'fraction' : 'bullets'
            },
            autoplay: {
                delay: sliderAutoPlay ? sliderAutoplay : 5000,
            },
            breakpoints: {
                1199: { //tablet down
                    slidesPerView: sliderSizeMedium ? sliderSizeMedium : 1,
                    // loopedSlides: sliderSizeMedium ? sliderSizeMedium : 1,
                    // slidesPerGroup: sliderSizeMedium ? sliderSizeMedium : 1,
                    // loopAdditionalSlides: sliderSizeMedium ? sliderSizeMedium : 1
                },
                767: { //mobile down
                    slidesPerView: sliderSizeSmall ? sliderSizeSmall : 1,
                    // loopedSlides: sliderSizeSmall ? sliderSizeSmall : 1,
                    // slidesPerGroup: sliderSizeSmall ? sliderSizeSmall : 1,
                    // loopAdditionalSlides: sliderSizeSmall ? sliderSizeSmall : 1
                },

            },
        })
    },

    init() {
        this.el.sliderContainer.each((i,e) => {
            const sliderItems = $(e).find('.swiper-slide');
            if (sliderItems.length > 1) {
                sliders.events(e);
            }
        })
    }
};

sliders.init();